import './DashboardContainer.scss'
import React, { useEffect } from 'react'
import { useNavigate, useLocation, Navigate } from 'react-router-dom'
import { RoutesEnum } from '../core/enums'
import { type IRoute } from '../core/types'
import Routes from '../Routes'
import { useAppSelector } from '../hooks/useReduxToolkit'

import Sidebar from '../components/Sidebar/Sidebar'
import Header from '../components/Header/Header'
import FirstPage from '../pages/AdminDashboad/FirstPage'
import Settings from '../pages/Settings/Settings'
import OppDashboard from '../pages/Opportunity/Opportunity'
import SupportDashboard from '../pages/Support/Support'
import FileManagerPage from '../pages/Files/FileManagerDrive'

const routes: IRoute[] = [
  {
    path: RoutesEnum.TermsConditions,
    element: <Navigate to="https://teammateai.com/terms-of-service/" replace />
  },
  {
    path: RoutesEnum.PrivacyPolicy,
    element: <Navigate to="https://teammateai.com/privacy-policy/" replace />
  },
  {
    path: RoutesEnum.Settings,
    element: <Settings />
  },
  {
    path: RoutesEnum.Opportunities,
    element: <OppDashboard />
  },
  {
    path: RoutesEnum.Support,
    element: <SupportDashboard />
  },
  {
    path: RoutesEnum.FileManager,
    element: <FileManagerPage />
  },
  {
    path: '/',
    element: <FirstPage />
  },
  {
    path: '*',
    redirectTo: '/',
    element: <FirstPage />
  }
]

const clientRoutes: IRoute[] = [
  {
    path: RoutesEnum.TermsConditions,
    element: <Navigate to="https://teammateai.com/terms-of-service/" replace />
  },
  {
    path: RoutesEnum.PrivacyPolicy,
    element: <Navigate to="https://teammateai.com/privacy-policy/" replace />
  },
  {
    path: RoutesEnum.Settings,
    element: <Settings />
  },
  {
    path: RoutesEnum.Opportunities,
    element: <OppDashboard />
  },
  {
    path: RoutesEnum.Support,
    element: <SupportDashboard />
  },
  {
    path: RoutesEnum.FileManager,
    element: <FileManagerPage />
  },
  {
    path: '/',
    element: <Navigate to={RoutesEnum.Support} replace />
  },
  {
    path: '*',
    element: <Navigate to={RoutesEnum.Support} replace />
  },
]

export default function DashboardContainer (): React.ReactElement {
  const isAdmin = useAppSelector(s => s.user.user.isAdmin)
  const companyId = useAppSelector(s => s.user.user.companyId)
  const navigate = useNavigate()
  const location = useLocation()

  // Append clientId to URL if not present
  useEffect(() => {
    if (!isAdmin && companyId !== null) {
      const currentPath = location.pathname === RoutesEnum.VerifyMagicLink ? RoutesEnum.Support : location.pathname
  
      // Ensure only 'Client' parameter is preserved
      const searchParams = new URLSearchParams()
      searchParams.set('Client', companyId)
  
      // Redirect to the correct path with the 'Client' parameter
      navigate(`${currentPath}?${searchParams.toString()}`, { replace: true })
    }
  }, [isAdmin, companyId, location.pathname, navigate])

  console.log('isAdmin:', isAdmin)

  console.log('Mapped Client Routes:', clientRoutes)

  return (
    <div className="DashboardContainer">
      <Header logoVisible={true} />
      <Sidebar />
      <div className="main-content">
        {isAdmin
          ? <Routes routes={routes} />
          : <Routes routes={clientRoutes} />
        }
      </div>
    </div>
  )
}
